module.exports = __webpack_public_path__ + "static/fonts/Robotoregular.18d44f79.ttf";